<div class="page-wrapper">
  <div class="pb-2">
    <p class="h3">Plage horaire</p>
  </div>

  <div class="section-wrapper mb-5">
    <div class="justify-content-between d-flex align-items-center mb-3">
      @if (extensions.length === 0) {
        <p class="extension-message">
          Pour étendre les horaires d’ouverture et ou de fermeture cliquez sur le bouton
          “Ajouter une extension”
        </p>
      } @else {
        <span class="extension-message fw-semibold">Liste des extensions de la raffinerie</span>
      }
      @if (canAddExtension) {
        <button type="button" class="btn btn-primary d-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#addExtensionDialog">
          <icon type="add_circle_outline" />
          Ajouter une extension
        </button>
      }
    </div>

    @if (extensions.length === 0) {
      <div class="empty-message mb-3">
        Vos extensions d'horaires apparaîtront ici comme dans l’exemple ci dessous :
      </div>
      <div class="d-flex justify-content-between align-items-center bg-white shadow-sm rounded-3 px-4 py-3">
        <div class="col">jj/mm/aaaa</div>
        <div class="col">hh : mm</div>
        <div class="col">hh : mm</div>
        <div class="col-auto"></div>
      </div>
    } @else {
      <div class="d-flex justify-content-between fw-semibold px-4 py-2">
        <div class="col-3">Date</div>
        <div class="col-3">Horaire d'ouverture</div>
        <div class="col-3">Horaire du dernier appel</div>
        <div class="col-3 text-end"></div>
      </div>

      <div class="d-flex flex-column gap-2">
        @for (extension of extensions; track $index) {
          <div class="d-flex justify-content-between align-items-center bg-white border border-gray-300 rounded-2 px-4 py-2 my-2">
            <div class="col-3">{{ extension.extensionDay }}</div>
            <div class="col-3">{{ extension.morningExtensionStart?.startHour ?? defaultOpeningHour?.startHour }}</div>
            <div class="col-3">{{ extension.eveningExtensionStart?.startHour ?? defaultLastCallHour?.startHour }}</div>
            <div class="col-3 text-end">
              @if (canAddExtension) {
              <text-typography pTooltip="{{getDeleteButtonTooltip(extension.extensionDay)}}"
                               tooltipPosition="left" tooltipStyleClass="tooltip-delete bold-text-xs">
                <span [ngClass]="{'material-icons-outlined': true, 'pointer': canDelete(extension.extensionDay), 'text-muted': !canDelete(extension.extensionDay)}"
                      aria-hidden="true"
                      [attr.data-bs-toggle]="canDelete(extension.extensionDay) ? 'modal' : null"
                      [attr.data-bs-target]="canDelete(extension.extensionDay) ? '#deleteExtensionsConfirmDialog' : null"
                      (keydown)="canDelete(extension.extensionDay) && (selectedExtensionId = extension.id)"
                      (click)="canDelete(extension.extensionDay) && (selectedExtensionId = extension.id)"
                      [style.pointer-events]="canDelete(extension.extensionDay) ? 'auto': 'none' ">
                delete</span>
              </text-typography>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>

<modal-element [id]="'addExtensionDialog'" [header]="'Ajouter une extension'" [modalContentClass]="'modal-asph-1'">
  <ng-container body>
    <form [formGroup]="extensionForm">
      <div class="form-group ms-3">
        <label for="date">Date de l'extension</label>
        <p-calendar
          formControlName="date"
          [minDate]="this.firstOpenedDays"
          [dateFormat]="dateFormat"
          [showIcon]="true"
          inputId="date"
          [readonlyInput]="true"
          [styleClass]="'full-width'"
          [iconDisplay]="'input'">
        </p-calendar>
      </div>

      <div class="row d-inline-flex justify-content-center align-items-center w-100 ms-1">
        <div class="form-group col-5">
          <label>Horaire d'ouverture</label>
          <div class="radio-options">
            <div *ngFor="let openingTime of openingTimeOptions" class="radio-option">
              <input
                type="radio"
                name="openingTime"
                [id]="'opening-' + openingTime"
                [value]="openingTime"
                formControlName="openingTime">
              <label [for]="'opening-' + openingTime" class="mt-2">{{ openingTime?.startHour?.slice(0, 5) }}</label>
            </div>
          </div>
        </div>

        <div class="col-2 fs-2">→</div>

        <div class="form-group col-5">
          <label>Horaire du dernier appel</label>
          <div class="radio-options">
            <div *ngFor="let lastCallTime of lastCallTimeOptions" class="radio-option">
              <input
                type="radio"
                name="lastCallTime"
                [id]="'lastCall-' + lastCallTime"
                [value]="lastCallTime"
                formControlName="lastCallTime">
              <label [for]="'lastCall-' + lastCallTime" class="mt-2">{{ lastCallTime?.startHour?.slice(0, 5) }}</label>
            </div>
          </div>
        </div>
      </div>
      @if (extensionForm.invalid) {
        <span class="text-danger d-block text-end w-100">Veuillez sélectionner au moins un horaire étendu.</span>
      }
    </form>
  </ng-container>

  <ng-container footer>
    <div class="d-flex justify-content-between w-100 mx-4">
      <button type="button" class="btn btn-tertiary d-inline-flex" data-bs-dismiss="modal">
        <icon type="close"></icon> Annuler
      </button>   
      <button type="submit"
              class="btn btn-primary d-inline-flex"
              data-bs-dismiss="modal"
              [disabled]="extensionForm.invalid"
              [ngClass]="{ 'btn-disabled': extensionForm.invalid }"
              (click)="saveExtension()">
        <icon type="check"></icon> Appliquer
      </button>
    </div>
  </ng-container>
</modal-element>
<modal-element [id]="'deleteExtensionsConfirmDialog'" [header]="'Supprimer l\'extension'" [modalContentClass]="'modal-asph-1 p-2'">
  <ng-container body>
    Êtes-vous sûr(e) de vouloir supprimer l'extension ?
  </ng-container>
  <ng-container footer>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">annuler</button>
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="deleteExtensions(selectedExtensionId)">Oui, supprimer</button>
  </ng-container>
</modal-element>
